module.exports = __webpack_public_path__ + "static/whyweimg-5aa605801b8f9c8079e66bbe18694ba7.jpg";